"use strict";


var _ = require('underscore');
var $ = require('dibs-jquery-shim');
var autoFetch = function () {
    if (this._lastFetch) {
        // fetch already happened, return the last fetch attempt's promise
        return this._lastFetch;
    }
    this._discreteIds = this.invoke('get', 'id');
    this._lastFetch = this.fetchWithParameters ? this.fetchWithParameters() : this.fetch();
    return this._lastFetch;
};

/**
 *
 * @mixin FetchDiscrete
 *
 * fetchDiscrete is a static mixin for collections that offers a fetchDiscrete method that will return a deferred that will resovle to an inflated model specified by the ID passed
 *
 * Configuration:
 *  add this._discreteIds to your URL when they are present
 *      This is usually done by providing a custom URL on your collection. This function
 *      should use the values in this._discreteIds to build a URL for a request for specific
 *      models identified by this property.
 *  add fetchDiscrete as a static method on your Collection. Static properties can be
 *      specified in the second argument to Backbone.Collection.extend
 * Usage:
 *  Once your collection has been configured for makeDiscrete, you can get deferreds for
 *    specific models using calls of the following forms:
 *
 *    YourCollection.fetchDiscrete(uninflatedModel, collectionParams)
 *    YourCollection.fetchDiscrete(modelId, collectionParams)
with identical collectionParams values will be grouped into a single request. Sequential calls to fetchDiscrete with non-identical collectionParams values will cause a new request to be made.
 *
 * Notes:
 *  - Plays well with clump service.
 *  - Fetching models for anchor lists (see Anchors.js) was the original use-case for this mixin. Anchors know about models, but fetchDiscrete happens on collections. For this reason, to have getSourceModel automatically detect when a model can be fetched using fetchDiscrete, specify a defaultCollection property on your model's prototype that is the collection that getSourceModel should defer to for fetchDiscrete.
 */
module.exports = {
/**
 *   @param {Backbone.Model} uninflatedModel - an instance of Collection.prototype.model that will be inflated.
 *   @param {string|int} modelId - an id (string or int) of the model that you want Collection to fetch
 *   @param {object} collectionParams - (optional) query parameters passed during the request. Sequential calls to fetchDiscrete
 *   @return - a deferred that resolves to the item that was requested
 */
    fetchDiscrete : function (model, params) {
        var curfetcher;
        var fetched;
        var needsNewFetcher = !this._curfetcher || _.result(this._curfetcher, '_madeRequest');
        if (this._curfetcher && !needsNewFetcher) {
            if (!_.isEqual(this._curfetcher.params || {}, params || {})) {
                needsNewFetcher = true; // start anew if we need different params from the last request
            }
        }
        if (needsNewFetcher) {
            this._curfetcher = new this();
            this._curfetcher.params = params;
        }
        curfetcher = this._curfetcher;
        if ("string" === typeof model || "number" === typeof model) {
            model = {id: model};
        }
        curfetcher.add(model);
        model = curfetcher.get(model.id); // the collection may have vivified what we inserted into an actual model, so we get it back out here
        fetched = $.Deferred();
        _.defer(function () {
            curfetcher._madeRequest = true;
            autoFetch.apply(curfetcher).done(function () {
                var inflatedModel = curfetcher.get(model.id);
                console.assert(inflatedModel, "expected model for id " + model.id + " in response for collection");
                if (inflatedModel !== model) {
                    // not sure why this would ever happen, but it always does. Backbone should intelligently reuse the models in its collections upon fetch
                    model.set(inflatedModel.toJSON()); // assume the data of the inflated model
                }
                fetched.resolve(model);
            });
        });
        return fetched;
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/fetchDiscrete.js
// module id = 2042
// module chunks = 64